<astrade-category-edit-form [category]="category" [availableProductPropertiesArray]="availableProductPropertiesArray" (saveClick)="onSave($event)"></astrade-category-edit-form>
